var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeVerificationRequired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.429,
    height: 27.477,
    viewBox: "0 0 26.429 27.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12493",
    "data-name": "Group 12493",
    transform: "translate(-1546.9 -301.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37740",
    "data-name": "Path 37740",
    d: "M4.271,211.1a.543.543,0,0,0,.546.546H19.484a4.5,4.5,0,0,1-.027-.546,6.343,6.343,0,0,1,4.987-6.193,11.124,11.124,0,0,0-4.965-4.016,7.091,7.091,0,0,1-8.348-.011A11.059,11.059,0,0,0,4.271,211.1Z",
    transform: "translate(1542.629 112.477)",
    fill: "#f2ce43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37741",
    "data-name": "Path 37741",
    d: "M101.349,6.04A6.043,6.043,0,1,0,95.3,12.086,6.051,6.051,0,0,0,101.349,6.04Z",
    transform: "translate(1462.633 301.273)",
    fill: "#f2ce43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clock_1_",
    "data-name": "clock (1)",
    d: "M5.252,0A5.252,5.252,0,1,0,10.5,5.252,5.258,5.258,0,0,0,5.252,0Zm2.5,7.969a.437.437,0,0,1-.619,0L4.943,5.78a.436.436,0,0,1-.128-.309V2.626a.438.438,0,0,1,.875,0V5.29L7.75,7.35A.437.437,0,0,1,7.75,7.969Zm0,0",
    transform: "translate(1562.824 318.246)",
    fill: "#f2ce43"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeVerificationRequired);
export default __webpack_public_path__ + "static/media/DE-VerificationRequired.4bb7a971.svg";
export { ForwardRef as ReactComponent };